import React from 'react';
import { css, styled } from '@this/constants/themes';
import { media } from '@this/components/shared/atoms/media';
import type SegmentClass from '@this/src/domain/transit/segment';
import type SelectStore from '@this/src/domain/select_store';
import type Transit from '@this/src/domain/transit/transit';
import PackageRouteInfo from './PackageRouteInfo';
import SelectTransportBoxRightInOutlineTemplate from '../../right/right_in_outline.template';

interface PackageDetailProps {
  transport: Transit;
  selected: boolean;
  handleChange: (legSummaryIndex?: number) => void;
  store: SelectStore;
  segment: SegmentClass;
  segmentIdx: number;
  isRequestForm?: boolean;
  candidateCount: number;
}

const PackageDetail = ({
  transport,
  selected,
  handleChange,
  store,
  isRequestForm,
  segment,
  segmentIdx,
  candidateCount
}: PackageDetailProps) => {
  const isAirPackage = store.result.type === 'airPackage';
  const hasAir = transport.airExists();

  const renderPackageRightPanel = () => {
    return (
      <SelectTransportBoxRightInOutlineTemplate
        price={transport.price ?? undefined}
        isAdditional={false}
        priceRange={isAirPackage ? transport.price_range ?? undefined : undefined}
        includeTax={transport.includeTax}
        selected={selected}
        onClick={() => handleChange()}
        isRequestForm={isRequestForm || false}
        isRakutenPackage={transport.isRakutenPackage}
        alignPriceRight
        candidateCount={candidateCount}
      />
    );
  };

  return (
    <StyledContent $selected={selected}>
      <StyledLeft>
        {segment.legs.map((leg, i) => (
          <StyledSegment key={`package_leg_short_distance_${leg.text}`}>
            <PackageRouteInfo
              leg={leg}
              legIndex={i}
              segment={segment}
              segmentIdx={segmentIdx}
              hasAir={hasAir}
              omitOuterPadding
            />
          </StyledSegment>
        ))}
      </StyledLeft>
      {renderPackageRightPanel()}
    </StyledContent>
  );
};

const StyledContent = styled.div<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  ${props =>
    props.$selected &&
    css`
      border: 2px solid ${props.theme.linkColor};
    `}
`;

const StyledLeft = styled.div`
  flex-shrink: 10;
  width: 100%;
  padding: 8px 5px 8px 10px;
  margin: auto 0;
  box-sizing: border-box;

  ${media.spSmall`
    padding: 10px;
  `}
`;

const StyledSegment = styled.div`
  margin: 0;
  width: 100%;
  padding: 5px 0;
`;

export default PackageDetail;
